<template>
    <MainContentSearchable title="Listado de emails alternativos para los comunicados" id="emails" v-model="filters" :meta="loading ? {} : emails.meta" @updated="debouncedGetEmails">
        <template v-slot:header>
            <h3 class="card-title"></h3>
            <div class="card-tools my-3">
                <Button @click="showModal('add-email')">AÑADIR EMAILS</Button>
                <AddEmail @close="closeModal"></AddEmail>
            </div>
        </template>

        <template v-slot:content v-if="!loading && emails">
            <div class="table-responsive has-options">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(email, index) in emails.data">
                            <tr :key="index">
                                <td>{{ email.email }}</td>
                                <td class="text-center">
                                    <div :class="'btn-group ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                        <Button type="button" class="dropdown-toggle" @click.prevent="expandir(index)">OPCIONES</Button>
                                        <div :class="'dropdown-menu ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                            <button class="dropdown-item" @click="showModal('editar-email-' + email.id)">Editar</button>
                                            <button class="dropdown-item" @click="showModal('borrar-' + email.id)">Borrar</button>
                                        </div>
                                    </div>
                                </td>
                                <EditarEmail :email="email" @close="closeModal"></EditarEmail>
                                <BorrarEmail :email="email" @close="closeModal"></BorrarEmail>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6">
                                <LoaderComponent></LoaderComponent>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> 
        </template>
    </MainContentSearchable>
</template>

<script>
import LoaderComponent from '@/components/preloader/LoaderComponent';
import AddEmail from './modals/AddEmail';
import EditarEmail from './modals/EditarEmail';
import BorrarEmail from './modals/BorrarEmail';
import MainContentSearchable from "@/components/backend/components/MainContentSearchable";

export default {
    data() {
        return {
            emails: null,
            loading: true,
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                search_for: 'n_abonado',
                tipo: null
            },
            expand: [],
        }
    },
    created() {
        this.getEmails();
        this.debouncedGetEmails = _.debounce(this.getEmails, 500)
    },
    methods: {
        borrar(id) {
            this.loading = true;

            const params = {
                filters : {},
                comunicado_id: id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.borrar'), params).then(res => {
                this.expand = [];
                this.$toast.success(res.data.message);
                this.getEmail();
            }).finally(() => this.loading = false);
        },
        getEmails : function() {
            this.loading = true;

            const params = {
                filters : this.filters
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.emails.index'), params).then(res => {
                this.emails = res.data;
            }).finally(() => this.loading = false);
        },
        expandir(index) {
            if(this.expand.indexOf(index) >= 0) {
                this.expand.splice(this.expand.indexOf(index), 1);
            } else {
                this.expand.push(index);
            }
        },
        setPage(page) {
            this.filters.page = page;
            this.getEmails();
        },
        showModal(modal) {
            this.expand = [];
            this.$modal.show(modal);
        },
        closeModal(modal, borrado) {
            this.$modal.hide(modal);
            if(borrado) {
                this.getEmails();
            }
        },
    },
    components: {
        LoaderComponent, AddEmail, EditarEmail, BorrarEmail, MainContentSearchable
    }
}
</script>
